import React, { useContext } from "react";
import Select from "react-select";
import { updateUser } from "../../store/reducers/currentUserSlice";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { auth } from "@mysnowscape/snow-lib";
import { useQuery } from "@tanstack/react-query";
import { AuthContext } from "../../AuthContext";
/**
 * Until the app supports switching companies gracefully across pages, we will require whitelisting here
 * to allow a page to not be redirected to the home when the user switches companies.
 */
const routeToNavigateToAfterSwitchingCompany = (url) => {
  // return null;
  // eslint-disable-next-line no-unreachable
  let newRoute = "/admin/route";
  const pathToRoute = [
    {
      regex: /admin\/property\/history.*/,
      to: "/admin/property/history",
    },
    {
      regex: /admin\/property.*/,
      to: "/admin/property/",
    },
    {
      regex: /admin\/timeclock.*/,
      to: "/admin/timeclock",
    },
    {
      regex: /admin\/employee\/manage-admins.*/,
      to: "/admin/employee/manage-admins",
    },
    {
      regex: /admin\/employee.*/,
      to: "/admin/employee",
    },
    {
      regex: /admin\/report.*/,
      to: "/admin/report",
    },
    {
      regex: /admin\/material.*/,
      to: "/admin/material",
    },
    {
      regex: /admin\/company\/services.*/,
      to: "/admin/company/services",
    },
    {
      regex: /admin\/active-routes.*/,
      to: "/admin/active-routes",
    },
    {
      regex: /admin\/settings.*/,
      to: null,
    },
  ];
  for (const check of pathToRoute) {
    if (check.regex.test(url)) {
      newRoute = check.to;
      break;
    }
  }
  return newRoute == url ? null : newRoute;
};

const SwitchCompanyDropdown = ({ currentUser }) => {
  const { tokenAvailable } = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const companyQuery = useQuery({
    queryKey: [`user/${currentUser.uid}/companies`],
    enabled: () => !!currentUser.uid && tokenAvailable,
  });
  const companyQueryData = companyQuery.data?.userCompanies
    ?.filter((c) => auth.canAdminCompany(currentUser, c.companyId))
    .map((c) => ({
      label: c.companyName + (c.isPaid ? "" : " (inactive)"),
      value: c.companyId,
    }));

  const { pathname } = useLocation();
  const handleChangeCompany = async (companyId) => {
    dispatch(
      updateUser({
        ...currentUser,
        currentCompanyId: companyId,
        isPaid: true,
        isPaidUpdatedAt: Date.now(),
      }),
    );

    const targetRoute = routeToNavigateToAfterSwitchingCompany(pathname);
    if (targetRoute) {
      navigate(targetRoute);
    }
    return;
  };

  return (
    <>
      <Select
        isLoading={companyQuery.isPending}
        onChange={(option) => handleChangeCompany(option.value)}
        options={companyQueryData}
        placeholder="Select Company"
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderColor: "#829399",
          }),
        }}
        value={companyQueryData?.find(
          (o) => o.value == currentUser.currentCompanyId,
        )}
      />
    </>
  );
};
export default connect((state) => ({ currentUser: state.currentUser }))(
  SwitchCompanyDropdown,
);
export { SwitchCompanyDropdown };
